(function () {
  var KEY = 'cdc-theme';
  var root = document.documentElement;
  var button = null;

  function current() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function apply(mode) {
    if (mode === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    if (button) {
      button.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      button.setAttribute('aria-label', mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      button.setAttribute('title', mode === 'dark' ? 'Light mode' : 'Dark mode');
    }
  }

  var ICONS =
    '<svg class="dm-moon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>' +
    '<svg class="dm-sun" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';

  function build() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dm-toggle';
    b.innerHTML = ICONS;
    b.addEventListener('click', function () {
      apply(current() === 'dark' ? 'light' : 'dark');
    });
    return b;
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function findBar() {
    return document.querySelector('[class^="ai-announcement-bar-"]') || document.querySelector('announcement-bar');
  }

  function place() {
    if (!button) return;
    var bar = findBar();
    var actions = document.querySelector('header-actions');

    if (bar && isVisible(bar) && window.innerWidth >= 900) {
      if (button.parentNode !== bar) {
        button.className = 'dm-toggle dm-toggle--bar';
        bar.style.position = 'relative';
        bar.appendChild(button);
      }
      return;
    }
    if (actions) {
      if (button.parentNode !== actions) {
        button.className = 'dm-toggle header-actions__action';
        actions.insertBefore(button, actions.firstChild);
      }
      return;
    }
    if (button.parentNode !== document.body) {
      button.className = 'dm-toggle dm-toggle--floating';
      document.body.appendChild(button);
    }
  }

  function mount() {
    if (!button) {
      button = build();
    }
    place();
    apply(current());
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(place, 150);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
